module.exports = __webpack_public_path__ + "img/ater.6ab9a703.png";